/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 10/15/2019
 *
 */

import React, {useState, useEffect} from 'react';
import './sidebar.css';
import {Link} from "react-router-dom";
import Links from "./sidebarLinks";

const SidebarContent = () => {
    // currently visible nav links in the sidebar
    const [currentNavLinks, setCurrentNavLinks] = useState([]);

    useEffect(() => {
        // take menus from 'sidebarLinks.js'
        let menus = Links;

        // initialize the created nav menus
        let navLinks = [];

        // get user credentials
        let userRole = JSON.parse(localStorage.getItem('tmcUser')).role;

        menus.forEach(mainMenu => {
            // check user has access for main menu
            if (mainMenu.roles.indexOf(userRole) > -1) {
                const subMenus = [];

                mainMenu.subMenus.forEach(subMenu => {
                    // check user has access for sub menu and has roles
                    if (subMenu.roles !== undefined) {
                        if (subMenu.roles.indexOf(userRole) > -1) {
                            subMenus.push(
                                <li key={subMenu.id} className="subMenu">
                                    <Link to={subMenu.link}>
                                        <i className={subMenu.icon}/>
                                        <span className="nav-text">{subMenu.name}</span>
                                    </Link>
                                </li>
                            )
                        }
                    } else {
                        // need to refresh the page to load the sidebar links
                        window.location.reload();
                    }
                });

                navLinks.push(Object.assign(mainMenu, {subMenus: subMenus}));
            }
        });

        setCurrentNavLinks(navLinks);
    },[]);

    // visibility for the sub menus when click the main menu
    const setSubMenuVisibility = (item) => {
        const existingNavLinks = currentNavLinks;

        setCurrentNavLinks(
            existingNavLinks.map(i =>
                (i.id === item.id) ? Object.assign(i, {isVisibleSubMenu: !i.isVisibleSubMenu}): i
            )
        );
    };

    return(
        <ul>
            {
                currentNavLinks.map(i => {
                    return (
                        <li key={i.id}>
                            <ul>
                                <li className="mainMenu">
                                    <span onClick={() => setSubMenuVisibility(i)}>
                                        <i className={i.icon}/>
                                        <span className="nav-text">{i.category}</span>
                                    </span>
                                </li>
                                {i.isVisibleSubMenu && i.subMenus}
                            </ul>
                        </li>
                    )
                })
            }
        </ul>
    )
};

export default SidebarContent;
